import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const ActionArrowRight: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M11.073 26.687c.347 0 .68-.134.947-.387L22.3 16.02 12.02 5.74c-.52-.52-1.36-.52-1.88 0-.52.52-.52 1.36 0 1.88l8.387 8.387-8.387 8.386a1.328 1.328 0 0 0 .947 2.267l-.014.027Z"
    />
  </Icon>
);
